export const askQuestionsPage = {
    stepMakeQuestion: {
        title: 'Ring hvis du har spørgsmål - opkald behandles altid fortroligt',
        subtitleInfo1: 'Vi har også lavet en ',
        faq: 'FAQ',
        subtitleInfo2: ', hvor du kan finde svar på de fleste spørgsmål om ',
        subtitleInfo3: ' whistleblowerordningen.',
    }
};
